import { inject, Injectable } from '@angular/core';
import { PromptDialogComponent } from './dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  dialog = inject(MatDialog);
  snackBar = inject(MatSnackBar);

  showDialog(title: string, text: string, showConfirmOnly?: boolean) {
    return this.dialog.open(PromptDialogComponent, {
      data: {
        title,
        text,
        showConfirmOnly,
      },
    });
  }

  showSnackBar(message: string, action: string, duration?: number) {
    return this.snackBar.open(message, action, {
      duration: duration || 5000,
      panelClass: ['custom-snackbar'],
    });
  }
}
